import {
  extractBaggageCount,
  extractSeatsCodes,
  extractSeatsCount,
  extractPackage,
  extractProducts,
} from './products-page';
import { extractSearchFormData } from './main-page';
import {
  extractSearchPageOpenData,
  prepareSearchAnalyticsData,
  getCityInfoFromDict,
  enrichEventWithCityData,
  enrichEventWithPassengerData,
  enrichEventWithCabinClass,
  enrichEventWithDatesAndSearchMode,
  enrichEventWithTravelType,
  getConnectType,
  getConnectTypeRange,
} from './search-page';
import { extractOfferData } from './details-page';
import { getOfferDetailsOpenLabel } from './offer-details-open-label';
import {
  getPointData,
  getSegmentData,
  getSegmentsDataFromOffer,
  getSegmentsDataFromMappedFlights,
  getBaggageFlagsFromSegmentsData,
} from './segments';

export const extractAnalyticsDataLib = {
  products: extractProducts,
  package: extractPackage,
  baggageCount: extractBaggageCount,
  seatsCount: extractSeatsCount,
  searchForm: extractSearchFormData,
  seatsCodes: extractSeatsCodes,
  searchPageOpen: extractSearchPageOpenData,
  offer: extractOfferData,
  getOfferDetailsOpenLabel,
  prepareSearchAnalytics: prepareSearchAnalyticsData,
  getCityInfoFromDict,
  enrichEventWithCityData,
  enrichEventWithPassengerData,
  enrichEventWithCabinClass,
  enrichEventWithDatesAndSearchMode,
  enrichEventWithTravelType,
  getConnectType,
  getConnectTypeRange,
  getPointData,
  getSegmentData,
  getSegmentsDataFromOffer,
  getSegmentsDataFromMappedFlights,
  getBaggageFlagsFromSegmentsData,
};

export * as extractAnalyticsDataTypes from './types';
